//-------------------------------------------------------------------------------------------------- Imports
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ResponsePopUp } from "../../types/common";


//-------------------------------------------------------------------------------------------------- Interfaces
interface AlertImageSliceInterface {
    show: boolean;
    onPressBtnPrimary?: Function;
    onPressBtnSecondary?: Function;
    popupData?: ResponsePopUp
};



//-------------------------------------------------------------------------------------------------- Vars and consts
const alertImageSliceInitialState = {
    show: false,
    onPressBtnPrimary: undefined,
    onPressBtnSecondary: undefined,
} as AlertImageSliceInterface;



//-------------------------------------------------------------------------------------------------- Slice
const alertImageSlice = createSlice({
    name: "alertImage",
    initialState: alertImageSliceInitialState,
    reducers: {
        setAlertImage: (state, action: PayloadAction<AlertImageSliceInterface>) => {
            state.show = action.payload.show;
            state.onPressBtnPrimary = () => { (action.payload.onPressBtnPrimary) && action.payload.onPressBtnPrimary() };
            state.onPressBtnSecondary = () => { (action.payload.onPressBtnSecondary) && action.payload.onPressBtnSecondary() };
            state.popupData = action.payload.popupData;
        },
        showAlertImage: (state, action: PayloadAction<boolean>) => {
            state.show = action.payload;
        },
        clearAlertImage: (state) => {
            state.show = alertImageSliceInitialState.show;
            state.onPressBtnPrimary = alertImageSliceInitialState.onPressBtnPrimary;
            state.onPressBtnSecondary = alertImageSliceInitialState.onPressBtnSecondary;
            state.popupData = alertImageSliceInitialState.popupData;
        }
    }
});



//-------------------------------------------------------------------------------------------------- Exports
export const { setAlertImage, showAlertImage, clearAlertImage } = alertImageSlice.actions;
export const getAlertImageData = (state: any) => (state.alertImage) as AlertImageSliceInterface;
export default alertImageSlice.reducer;
